import fabric from '@/lib/fabric';

export type PenPoint = { x: number; y: number };

/** Build an SVG path from click points (polyline). */
export function pointsToPathData(points: PenPoint[]): string {
  if (!points.length) return '';
  const [first, ...rest] = points;
  return `M ${first.x} ${first.y}${rest.map((p) => ` L ${p.x} ${p.y}`).join('')}`;
}

export function createPenPreview(
  points: PenPoint[],
  stroke: string,
  strokeWidth: number
): fabric.Path | null {
  if (points.length < 1) return null;
  const path = new fabric.Path(pointsToPathData(points), {
    fill: '',
    stroke,
    strokeWidth,
    selectable: false,
    evented: false,
    objectCaching: false,
    strokeLineCap: 'round',
    strokeLineJoin: 'round',
  });
  return path;
}

export function finalizePenPath(
  canvas: fabric.Canvas,
  points: PenPoint[],
  stroke: string,
  strokeWidth: number,
  opacity: number
): fabric.Path | null {
  if (points.length < 2) return null;
  const path = new fabric.Path(pointsToPathData(points), {
    fill: '',
    stroke,
    strokeWidth,
    opacity,
    selectable: true,
    evented: true,
    strokeLineCap: 'round',
    strokeLineJoin: 'round',
  });
  canvas.add(path);
  canvas.setActiveObject(path);
  path.setCoords();
  canvas.requestRenderAll();
  return path;
}
